var _path, _rect, _path2, _path3, _path4, _line, _line2, _line3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 342 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0H312C328.569 0 342 13.4315 342 30V280H0V30Z",
    fill: "#FF7FE3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 71,
    width: 198.397,
    height: 209,
    fill: "url(#pattern0_1061_465)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.112 111.987C101.049 111.967 100.982 111.962 100.916 111.972C100.851 111.982 100.788 112.006 100.734 112.043C100.679 112.081 100.633 112.13 100.6 112.187C100.567 112.244 100.547 112.308 100.542 112.374L100.529 112.699C100.636 112.781 100.722 112.887 100.779 113.009C100.836 113.131 100.863 113.265 100.858 113.399C100.852 113.534 100.815 113.665 100.748 113.782C100.681 113.899 100.587 113.998 100.474 114.071L100.456 114.512C100.458 114.61 100.49 114.705 100.547 114.785C100.603 114.864 100.683 114.925 100.775 114.959C101.789 115.36 102.513 116.059 102.482 116.808L102.481 116.833C102.477 116.912 102.489 116.991 102.516 117.066C102.543 117.14 102.585 117.208 102.638 117.266C102.692 117.325 102.757 117.372 102.829 117.405C102.901 117.438 102.979 117.456 103.058 117.458L103.452 117.474C103.534 117.382 103.635 117.31 103.748 117.262C103.861 117.214 103.984 117.191 104.107 117.196C104.23 117.201 104.351 117.233 104.46 117.291C104.569 117.348 104.664 117.428 104.738 117.527L105.18 117.545C105.291 117.55 105.399 117.512 105.482 117.439C105.565 117.366 105.617 117.264 105.626 117.154L105.635 116.937C105.726 114.702 103.806 112.723 101.112 111.987Z",
    fill: "#0029FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.665 128.907C96.6705 128.771 96.7087 128.639 96.7765 128.521C96.8443 128.403 96.9397 128.303 97.0544 128.23L97.0747 127.731C97.0816 127.632 97.0569 127.533 97.0041 127.448C96.9513 127.364 96.8732 127.298 96.7808 127.261C95.7605 126.858 95.0411 126.179 95.0723 125.41C95.0752 125.248 95.0137 125.091 94.9012 124.973C94.7888 124.856 94.6344 124.788 94.4719 124.784L94.1761 124.772C94.0942 124.877 93.9882 124.962 93.8669 125.018C93.7457 125.074 93.6127 125.101 93.4791 125.095C93.3455 125.09 93.2151 125.053 93.0989 124.987C92.9826 124.921 92.8838 124.828 92.8107 124.716L92.3542 124.698C92.3003 124.695 92.2465 124.703 92.1958 124.722C92.1451 124.74 92.0986 124.769 92.059 124.805C92.0194 124.842 91.9875 124.886 91.9651 124.935C91.9427 124.984 91.9304 125.037 91.9287 125.091L91.9209 125.282C91.8291 127.541 93.7497 129.497 96.4415 130.256C96.5052 130.273 96.572 130.275 96.6368 130.263C96.7016 130.25 96.7627 130.223 96.8154 130.183C96.8682 130.144 96.9112 130.093 96.9412 130.034C96.9713 129.975 96.9875 129.911 96.9888 129.845L96.9983 129.611C96.8899 129.529 96.8029 129.422 96.7449 129.3C96.6868 129.177 96.6594 129.042 96.665 128.907Z",
    fill: "#0029FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.637 121.005C99.8203 120.065 95.2362 118.429 95.3073 116.68C95.3571 115.455 96.312 115.061 96.9244 114.917C97.0624 114.892 97.1877 114.821 97.2796 114.715C97.3715 114.609 97.4245 114.475 97.4297 114.335L97.4432 114.004C97.3301 113.923 97.239 113.815 97.1781 113.689C97.1171 113.564 97.0881 113.426 97.0938 113.287C97.0994 113.148 97.1395 113.012 97.2104 112.893C97.2814 112.773 97.3809 112.672 97.5002 112.601L97.5176 112.173C97.5182 112.068 97.4772 111.967 97.4036 111.891C97.33 111.816 97.2297 111.773 97.1244 111.771C94.6351 111.892 92.4294 113.942 92.3354 116.253C92.1802 120.074 95.9995 121.577 97.7978 122.392C99.5948 123.237 102.332 124.093 102.263 125.774C102.216 126.93 101.164 127.318 100.533 127.438C100.393 127.468 100.267 127.544 100.175 127.653C100.083 127.763 100.031 127.9 100.025 128.042L100.013 128.351C100.122 128.432 100.21 128.539 100.268 128.662C100.326 128.785 100.354 128.92 100.349 129.056C100.343 129.192 100.305 129.325 100.236 129.443C100.168 129.56 100.072 129.66 99.9568 129.732L99.9431 130.069C99.9399 130.121 99.948 130.173 99.967 130.221C99.986 130.27 100.015 130.313 100.053 130.349C100.091 130.385 100.136 130.413 100.185 130.429C100.234 130.446 100.287 130.452 100.339 130.446C102.391 130.337 105.153 128.788 105.245 126.53C105.381 123.184 103.431 121.95 101.637 121.005Z",
    fill: "#0029FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 233,
    y1: 116,
    x2: 248,
    y2: 116,
    stroke: "#0029FF",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 233,
    y1: 120,
    x2: 248,
    y2: 120,
    stroke: "#0029FF",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 233,
    y1: 124,
    x2: 248,
    y2: 124,
    stroke: "#0029FF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 129.783,
    y: 191,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 134.084,
    y: 199.601,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 150.427,
    y: 191,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#0029FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 154.727,
    y: 199.601,
    width: 6.88112,
    height: 1.72028,
    fill: "#0029FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 171.07,
    y: 191,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#0029FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 175.371,
    y: 199.601,
    width: 6.88112,
    height: 1.72028,
    fill: "#0029FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 191.713,
    y: 191,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 196.014,
    y: 199.601,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 131.503,
    y: 210.783,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#0029FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 135.804,
    y: 219.385,
    width: 6.88112,
    height: 1.72028,
    fill: "#0029FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 210.783,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 114.301,
    y: 219.385,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 153.007,
    y: 210.783,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 157.308,
    y: 219.385,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 174.51,
    y: 210.783,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#0029FF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 178.811,
    y: 219.385,
    width: 6.88112,
    height: 1.72028,
    fill: "#0029FF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 196.014,
    y: 210.783,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 200.315,
    y: 219.385,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 217.517,
    y: 210.783,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 221.818,
    y: 219.385,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 131.503,
    y: 230.566,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 135.804,
    y: 239.168,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 230.566,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 114.301,
    y: 239.168,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 153.007,
    y: 230.566,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#0029FF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 157.308,
    y: 239.168,
    width: 6.88112,
    height: 1.72028,
    fill: "#0029FF"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 174.51,
    y: 230.566,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 178.811,
    y: 239.168,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 196.014,
    y: 230.566,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#0029FF"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 200.315,
    y: 239.168,
    width: 6.88112,
    height: 1.72028,
    fill: "#0029FF"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 217.517,
    y: 230.566,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#0029FF"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 221.818,
    y: 239.168,
    width: 6.88112,
    height: 1.72028,
    fill: "#0029FF"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 131.503,
    y: 250.35,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#0029FF"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 135.804,
    y: 258.951,
    width: 6.88112,
    height: 1.72028,
    fill: "#0029FF"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 250.35,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#0029FF"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 114.301,
    y: 258.951,
    width: 6.88112,
    height: 1.72028,
    fill: "#0029FF"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 153.007,
    y: 250.35,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 157.308,
    y: 258.951,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 174.51,
    y: 250.35,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 178.811,
    y: 258.951,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 196.014,
    y: 250.35,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 200.315,
    y: 258.951,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 217.517,
    y: 250.35,
    width: 15.4825,
    height: 7.74126,
    rx: 3.87063,
    fill: "#D9D9D9"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 221.818,
    y: 258.951,
    width: 6.88112,
    height: 1.72028,
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117 140H224L215 162H126L117 140Z",
    fill: "#E9E9E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.575 194.5L85.635 197.2C85.68 197.305 85.67 197.455 85.67 197.565H85.745C85.745 197.45 85.735 197.305 85.775 197.2L86.83 194.5H87.235L85.945 198H85.465L84.175 194.5H84.575ZM87.8582 198V194.5H88.2332V198H87.8582ZM90.1176 196.54C89.9826 196.54 89.7476 196.54 89.5076 196.535V198H89.1326V194.5H90.1826C90.9226 194.5 91.5376 194.66 91.5376 195.5C91.5376 196.34 90.9276 196.54 90.1176 196.54ZM89.5076 196.185H90.1826C90.6926 196.185 91.1626 196.14 91.1626 195.49C91.1626 194.865 90.7326 194.86 90.1826 194.86H89.5076V196.185Z",
    fill: "#9A9A9A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.575 194.5L85.635 197.2C85.68 197.305 85.67 197.455 85.67 197.565H85.745C85.745 197.45 85.735 197.305 85.775 197.2L86.83 194.5H87.235L85.945 198H85.465L84.175 194.5H84.575ZM87.8582 198V194.5H88.2332V198H87.8582ZM90.1176 196.54C89.9826 196.54 89.7476 196.54 89.5076 196.535V198H89.1326V194.5H90.1826C90.9226 194.5 91.5376 194.66 91.5376 195.5C91.5376 196.34 90.9276 196.54 90.1176 196.54ZM89.5076 196.185H90.1826C90.6926 196.185 91.1626 196.14 91.1626 195.49C91.1626 194.865 90.7326 194.86 90.1826 194.86H89.5076V196.185Z",
    fill: "#ABABAB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.205 215.43C87.395 215.525 87.565 215.73 87.675 216.125C87.73 216.325 87.94 217 87.94 217H87.57C87.45 216.56 87.355 216.235 87.335 216.165C87.165 215.6 86.785 215.55 86.58 215.54C86.54 215.54 86.495 215.54 86.445 215.54C86.315 215.54 86.07 215.54 85.825 215.535V217H85.45V213.5H86.5C87.24 213.5 87.855 213.66 87.855 214.48C87.855 214.98 87.57 215.17 87.205 215.305C87.095 215.345 86.95 215.33 86.835 215.33V215.405C86.95 215.405 87.105 215.38 87.205 215.43ZM85.825 213.86V215.185H86.5C87.01 215.185 87.48 215.14 87.48 214.49C87.48 213.865 87.05 213.86 86.5 213.86H85.825ZM89.6741 214.33C89.4891 214.42 89.2641 214.475 89.0791 214.475V214.1C89.4441 214.1 89.7391 213.835 89.7391 213.5H90.2541V217H89.8791V214.44C89.8791 214.29 89.9541 214.125 90.0241 214L89.9591 213.96C89.8891 214.09 89.8041 214.265 89.6741 214.33Z",
    fill: "#9A9A9A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.205 215.43C87.395 215.525 87.565 215.73 87.675 216.125C87.73 216.325 87.94 217 87.94 217H87.57C87.45 216.56 87.355 216.235 87.335 216.165C87.165 215.6 86.785 215.55 86.58 215.54C86.54 215.54 86.495 215.54 86.445 215.54C86.315 215.54 86.07 215.54 85.825 215.535V217H85.45V213.5H86.5C87.24 213.5 87.855 213.66 87.855 214.48C87.855 214.98 87.57 215.17 87.205 215.305C87.095 215.345 86.95 215.33 86.835 215.33V215.405C86.95 215.405 87.105 215.38 87.205 215.43ZM85.825 213.86V215.185H86.5C87.01 215.185 87.48 215.14 87.48 214.49C87.48 213.865 87.05 213.86 86.5 213.86H85.825ZM89.6741 214.33C89.4891 214.42 89.2641 214.475 89.0791 214.475V214.1C89.4441 214.1 89.7391 213.835 89.7391 213.5H90.2541V217H89.8791V214.44C89.8791 214.29 89.9541 214.125 90.0241 214L89.9591 213.96C89.8891 214.09 89.8041 214.265 89.6741 214.33Z",
    fill: "#ABABAB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.205 235.43C87.395 235.525 87.565 235.73 87.675 236.125C87.73 236.325 87.94 237 87.94 237H87.57C87.45 236.56 87.355 236.235 87.335 236.165C87.165 235.6 86.785 235.55 86.58 235.54C86.54 235.54 86.495 235.54 86.445 235.54C86.315 235.54 86.07 235.54 85.825 235.535V237H85.45V233.5H86.5C87.24 233.5 87.855 233.66 87.855 234.48C87.855 234.98 87.57 235.17 87.205 235.305C87.095 235.345 86.95 235.33 86.835 235.33V235.405C86.95 235.405 87.105 235.38 87.205 235.43ZM85.825 233.86V235.185H86.5C87.01 235.185 87.48 235.14 87.48 234.49C87.48 233.865 87.05 233.86 86.5 233.86H85.825ZM89.3191 236.48C89.2241 236.585 89.0541 236.665 88.9191 236.725L88.9491 236.795C89.0841 236.735 89.2541 236.66 89.3991 236.66H90.7941V237H88.5841V236.66C89.0741 236.165 89.2941 235.885 89.9641 235.215C90.7491 234.43 90.3591 233.805 89.7741 233.805C89.1891 233.805 89.0541 234.125 89.0541 234.5H88.6391C88.6391 233.99 88.9091 233.425 89.7741 233.425C90.6391 233.425 91.1441 234.455 90.4691 235.2C90.0191 235.7 89.5591 236.215 89.3191 236.48Z",
    fill: "#9A9A9A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.205 235.43C87.395 235.525 87.565 235.73 87.675 236.125C87.73 236.325 87.94 237 87.94 237H87.57C87.45 236.56 87.355 236.235 87.335 236.165C87.165 235.6 86.785 235.55 86.58 235.54C86.54 235.54 86.495 235.54 86.445 235.54C86.315 235.54 86.07 235.54 85.825 235.535V237H85.45V233.5H86.5C87.24 233.5 87.855 233.66 87.855 234.48C87.855 234.98 87.57 235.17 87.205 235.305C87.095 235.345 86.95 235.33 86.835 235.33V235.405C86.95 235.405 87.105 235.38 87.205 235.43ZM85.825 233.86V235.185H86.5C87.01 235.185 87.48 235.14 87.48 234.49C87.48 233.865 87.05 233.86 86.5 233.86H85.825ZM89.3191 236.48C89.2241 236.585 89.0541 236.665 88.9191 236.725L88.9491 236.795C89.0841 236.735 89.2541 236.66 89.3991 236.66H90.7941V237H88.5841V236.66C89.0741 236.165 89.2941 235.885 89.9641 235.215C90.7491 234.43 90.3591 233.805 89.7741 233.805C89.1891 233.805 89.0541 234.125 89.0541 234.5H88.6391C88.6391 233.99 88.9091 233.425 89.7741 233.425C90.6391 233.425 91.1441 234.455 90.4691 235.2C90.0191 235.7 89.5591 236.215 89.3191 236.48Z",
    fill: "#ABABAB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.205 254.43C87.395 254.525 87.565 254.73 87.675 255.125C87.73 255.325 87.94 256 87.94 256H87.57C87.45 255.56 87.355 255.235 87.335 255.165C87.165 254.6 86.785 254.55 86.58 254.54C86.54 254.54 86.495 254.54 86.445 254.54C86.315 254.54 86.07 254.54 85.825 254.535V256H85.45V252.5H86.5C87.24 252.5 87.855 252.66 87.855 253.48C87.855 253.98 87.57 254.17 87.205 254.305C87.095 254.345 86.95 254.33 86.835 254.33V254.405C86.95 254.405 87.105 254.38 87.205 254.43ZM85.825 252.86V254.185H86.5C87.01 254.185 87.48 254.14 87.48 253.49C87.48 252.865 87.05 252.86 86.5 252.86H85.825ZM90.4891 254.31C90.6841 254.48 90.8041 254.715 90.7991 255.015C90.7991 255.7 90.4091 256.075 89.5941 256.075C88.8191 256.075 88.3591 255.73 88.3491 255.135H88.7241C88.7241 255.505 89.0591 255.725 89.6141 255.725C90.1791 255.725 90.4241 255.445 90.4241 255.02C90.4241 254.485 90.1541 254.345 89.1391 254.345V253.995C90.1141 253.995 90.3791 253.885 90.3741 253.38C90.3741 252.955 90.1441 252.775 89.6141 252.775C89.0891 252.775 88.7741 252.995 88.7741 253.365H88.3991C88.4091 252.77 88.8491 252.425 89.5941 252.425C90.3741 252.425 90.7491 252.7 90.7491 253.385C90.7491 253.655 90.6591 253.875 90.4891 254.035C90.3791 254.135 90.1941 254.14 90.0441 254.14L90.0491 254.215C90.1941 254.215 90.3791 254.215 90.4891 254.31Z",
    fill: "#9A9A9A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.205 254.43C87.395 254.525 87.565 254.73 87.675 255.125C87.73 255.325 87.94 256 87.94 256H87.57C87.45 255.56 87.355 255.235 87.335 255.165C87.165 254.6 86.785 254.55 86.58 254.54C86.54 254.54 86.495 254.54 86.445 254.54C86.315 254.54 86.07 254.54 85.825 254.535V256H85.45V252.5H86.5C87.24 252.5 87.855 252.66 87.855 253.48C87.855 253.98 87.57 254.17 87.205 254.305C87.095 254.345 86.95 254.33 86.835 254.33V254.405C86.95 254.405 87.105 254.38 87.205 254.43ZM85.825 252.86V254.185H86.5C87.01 254.185 87.48 254.14 87.48 253.49C87.48 252.865 87.05 252.86 86.5 252.86H85.825ZM90.4891 254.31C90.6841 254.48 90.8041 254.715 90.7991 255.015C90.7991 255.7 90.4091 256.075 89.5941 256.075C88.8191 256.075 88.3591 255.73 88.3491 255.135H88.7241C88.7241 255.505 89.0591 255.725 89.6141 255.725C90.1791 255.725 90.4241 255.445 90.4241 255.02C90.4241 254.485 90.1541 254.345 89.1391 254.345V253.995C90.1141 253.995 90.3791 253.885 90.3741 253.38C90.3741 252.955 90.1441 252.775 89.6141 252.775C89.0891 252.775 88.7741 252.995 88.7741 253.365H88.3991C88.4091 252.77 88.8491 252.425 89.5941 252.425C90.3741 252.425 90.7491 252.7 90.7491 253.385C90.7491 253.655 90.6591 253.875 90.4891 254.035C90.3791 254.135 90.1941 254.14 90.0441 254.14L90.0491 254.215C90.1941 254.215 90.3791 254.215 90.4891 254.31Z",
    fill: "#ABABAB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1061_465",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1061_465",
    transform: "scale(0.0030581 0.00290296)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1061_465",
    width: 327,
    height: 688,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUcAAAKwCAMAAAA86E1lAAABd1BMVEUAAADV1dXMzMz////////////////U1NTJycn////////Jycn////////////////+/v7V1dX////V1dX////////////////k5OTy8vL////09PTm5ubp6eni4uLj4+P////l5eXk5OTi4uLm5ub////m5ube3t7V1dX////////k5OT+/v7V1dX////+/v7////l5eXl5eXl5eX////U1NTi4uLU1NT8/PzV1dXo6Ojo6Oj+/v739/fX19f////////o6OjU1NT8/PzV1dXOzs7y8vLU1NT////w8PD+/v709PT////m5ubKysrq6urh4eHv7+/v7+/a2trm5ubT09Ph4eHS0tL////d3d3V1dXp6en+/v7Z2dno6OjS0tL9/f3b29vT09Pn5+f////////////v7+/i4uLz8/P////29vbz8/P5+fnw8PD9/f36+vrp6enj4+P8/Pzu7u7i4uLn5+ff39/Y2Njr6+vl5eXt7e3b29urppZiAAAAanRSTlMA9SD2IfIecB8gdBirb+30GO6mdLZws66gESPofEiPBrComnRhqIoL8vG4eenoyNW8lYJGGwT3iYVbWFNOLyagXk5BOzUS78t7FxP44Dcd9Ovi0sC9pG5P+d3VzJKOfGlFRbmvamVY5sq6yaKr5QAADwhJREFUeNrsnXtvEkEUR63a+qrGZxuNBo02lYrQxFbRUGtEo5JGje/4js+4M7ssFGgBP7zDAlKQ1mVnzI7pOZTdtn+e/O7cO7N97AjPYuFUPvfty/7s2+XlowHqtoGZ/tuM+lC3yZmZydZbXdRLoa5DmQ4u05Pqpe5np4OPyekeZ4P32fZdMdV6T00Flx6dr44r1LV770d9e069AtQnAfPH5+YD5qaOvr3/5VYuf6qQ2GGaidz96Uxql7OdeJXKTGdz+4w5nM1n00lnu5JMZ/OzBiwuZTNFZ5uTyS7pSUzc+CEcUDV+PJeIbvHCE9+BDulvEU2eeeM7276k+0x+jGDx5mdZ9NHYz/LEqBpffPfdVQcGSN0ayeLDz9J1CeMwlgvhNd5+4gqlkdVxGJnQM9CHR6KlsYjGoRzKhdN4viSVxuIqGjfh1ZcwGt81vZZGny6zOfdDaKx7Eo3aIq/VK9Jd9V2qemtObK1xT60phdLIfvAvFL9tpfHl1bonfF+wkfkr4/kt9oKP0RialYVND2yf1pvS9YXL5BiGqcRmPaZUl8IX9JiQ7N9kN3i1VpG+ELGOPEU/FFasPONLQ6v6Xq0uXSFjjaMvRTik68TP/LDKPtaoecKVscaxKPyQuNKGRN4aclR2pFGXSmOsJVOUStHqhpei+40BpA0j7krhzyZTq1Va5RLvhtCTbjiksCGPf+4Pd4614+jGu4IXRUjs0OikDg/GsdGoCCkF5xMjMRjIA5fLJc/1hGvFQPEfsXKy/wi8XK4LicdRGWjZi/fKqst4PNwanfmNHu+sl0tSVojj6Lxa2thlWmXtUdaanUaVterWFSl49D866cXeueNYteZJ5ZHlcXR2nep166paHiue4ABXr2M/LzfqssnyGI3lrsbEa7U8ymbsm8L/lEyiu7cOlscmbSYa4xPdg/Cf1ZLn0a6jku9vM3iMyNfeFN5qM5J2HY1sr13jUYOjHY+fAo8SjxGZ63hUu8ImHqOT/j0+1ip41B4gZy9XlccKHqOyMht4vItHPVIn8WjEY6H9jAuPmh4ftD0ewaMWhw7jEY/2gEc82gQe8WgTeMSjTQx45PE1HkeDuraSjR498hiJoqLr8TIetTymCqyPJujlsUEeIxLkseuRPGqpTDH3GID50bjHMh7JY/zgEY82gUc82gQe/8Xcw699kMeRwKOl4BGPNtHzSJ/hnCJ+yCMebYI+Y8jjQuDx4UXyaMLjXjzqkex59KhrDY8TnT+rwPqoxXjb494x6tqEx5t4NOHxTqa8VvPwqOvxvFNZI4/6Hi85kjwa6Nen8ajJeNcjda3nkTySR4sgj6Y9lvBIv46d5AIeWR/tIcn6yPpoEe26fo9H1kcrwCMebYL9DB5tYtAj//Wa9VEf/eczFTwa8PjCabA+GvB489k6edT2qDgwVsWjiZ/vwSMebaDjcWfgkX/jo+2RPOLRBroeL1aZH414JI9mPNJn6NcW0JsfSx2P1LXOvpA8GvF4BY8mPF4R6ryHujZwjotHI88ViutrJepa/+dSlEf6tRmP9BkDHqlrY+tjjefX+h6pa0Nzz0886ntcPOes4VHf43Xp1PCo7/GYcCp41Pe4RzgSjwY8Skdw3qPncSHwWBRV5nAdkkuJwCN51ORQejd5NMJBPBrhBHVNHi0Cj6Y9engkj7GDR0Me6dd4tAjqGo82wdxDHm0Cj3i0CTzSZ2yCPOLRJvDI+mgTeKSubQKPZjiBR/JoEfQZ8mgTeMSjTQT9WrI+6ufxmFz11vBowKMo8fuFBjx6XhWPBvpMrfqTujbg0ZN4NDL3uOt4NDH3iHXmHl3293nkz1P8YudechoHojCMhqbpp6IeREjdPUGICVtgLYyZxGUcUBRLwOIxCBYAdQf/4HxLOLpVrnIif9rRPBY6uhda1xlZ1xyT4ljnOLrPlDhOM8d+x82wvfN9ihLH2/lgHgscm3Vd4Ni2fr+ucPQ/gDJH90LzmJF5LHccOFrXH4xjaPZHjklx9LxOyjx6XidlHjkmxZFjUhw5JuUcbh6TWv5PwZFjTBw5JrU4el6bx5h++T5Ff5N1XeNoXZc07jhWNDSOJY4P45pjf9NuOn15T9E49rZebYbdfubY79iGw+zc09myrvePM8d+x++H+yf7Y4FjG5/MY1/v30txL6yYx4Fjd2uOJZ36PgXHoKxr85gUR+s6qWUeB44cU+JY5+g5436dEkeOSXH0nEnKPLoXJmUeve9JyjxyTIqj/TEp53DvH5OyP1a041jSuL3h2N90/fef/bG/k2+r1WrDsbc/P18dG8cKx7Z3fixwvLrdm8cCx7OL8yOO3Y5Lvy/vORY4fjniyDEgjhyT4sgxqTfHHxzNY0IcOSbFkWNSHDkmxZFjUhw5JsWRY1IcOSbFkWNSHDkmxbGmE44lHX/lyDEnjhyT4sgxKY4ck+LIMSmOHJPiyDEpjhyT4sgxKY4ck+LIMSmOHJPiyDEpjhyT4sgxKY4ck+LIMSmOHJPiyDGp4/8cix0bR/P44eyPkZlHjklx5JgUR45JcXR+TIqjdZ0UR+97kjKPHJPi6NyTFEeOSXH0nEmKI8ek7I8ck+LIMSmOz+zdMQ6CQBQA0QqCFfc0FibK/e1sbCQsYYo3R3j5uwsbEkY5un80j504cizFkWMpjhxLceRYiiPHUt6vzWMpjhxLcTzH8cmR446s62YcOZbiyLEUR9/tlVpv7ntGNM3mkWOn1X/tB50z3q+d1508P9ofS5lHjqU4cizFkWMpjhxLceRYiiPHUhw5luLIsRRHjqU4cizFkWMpjhxLceRYiiPHUhw5luLIsRRHjqU4nuH44Gge98QxGkeOpThyLMWRYymOHEtx5FiKI8dS7s3MYymOHEtx5FiKI8dSHD2HlzKPHEtx5FiKI8dSHDmW4sixFEeOpdxTcCxlXZvHUubRPJYyjxxLWdfmsRRHjqV+9sfXXc6Zf+MYzf7IsZR1zbEUR46lOHIsxZFjKfcUHEtZ1xxLceRYyr2ZeSxlHj0/lrKuOZbiaH8sZR45luLIsRRH53UpjhxLceRY6uu4cTSP18eRYymOHEtx5FiKI8dSHE9wfHM0j7viGI2j/bEUx8GOG0f74/VZ1+axFMehjgvHY02zeRzouPjejGOhafb9o/2xk3nkWMo582Hnzo0QhoIgiNpyUBqQDKngCOJHVRwBSGu08TqErpndr5PHEjza1yV4nPLoPoU8duBRr0vwyGMJHnkswSOPJXjksQSPPJb4efS+mTwW4JHHEuYjjyX0Wh5L8KjXJXgc8rjotfnYgUfzsYT5qNcl9JrHEubjlEf/A5DHDuYjjyWcH6c82jO+V+hgX+t1Cedw+7qE+Tjl0TlcrzvY1/Z1CXuGxxJ6LY8leOSxBI/O4SXWbx6vz9fm+voYj53bJ4/33aM8nhB58XxmhHX553GTx3d7Z/qbRBDG4Ynxm4lWPxg8KOEIqHgBFg+02koxiNjWVhuvpNUYDTOzB7uuAv7xzrXTVaDAsGpN3weZGXa72Dz83tlhQ1szbI/l8ZacH6Gu58K+DOfrGID1YzzAdYq4OAV5hLo+REBdg8fDxH5dw/ox3jzCL7SPxaPTAQw4BR7jXT9+DT1CXRugP99zqRuAx/k9PgeP83H5FuKcOA0e5+LkAuKsXevK67gYPBpx9SniFMDjfDw7hzipN+BxLm6kkOCJ8gh/oMuM60jyoR/0uEd4g23GFSR52e8zjxaGNzRmPESS213m0bJg4WPIHSS5+7XrEgsWkKY8QpL6965rwQRpzGMkOaEWkBBII642kWKrGwyIDxOk8bJHcZufsC2xEofCnpl3KGTnm5ogIZAG3EcMfcXHx8IjBNLoao9+R9MfEMuCQBpwFnH0CrIHhW3GJ4Sihe36GAJpgPoQafQtNoEZcnbOoCirP2QgmUcI5EzsoihLT/rBIAwkiJye6ykk0Weafs9igYTKNrpGoSm86QcsjRDI2bhRQGhUIIkFIo3iqEk9CQKfVzYGkSazo2b1W7/nEywCSR34CN8U2LtoBC+D/kBXNiRyCh6iUZx43Xd9okRCaU/m2QIayQ6rbAtETsIOvdxHY3gfBFGRsI4cadFTHt+hcRS23GAQEQlnm2GLDvVYyzJ5s4DGcux14PoWoVykOtuASQ3352BH/Kxw58JxdACrG0wk0SLBZBTb8yh2bI9LaT1GB7JTlYnETKQ0CdWtLTqYaXQopR6uoQncrYpEYiZSRFKaPOqhtHkKKcaezVsH5xCaLNLlicSitpVJofKourS5RG6RUNujmHWtHJqCnQ0hklAsTWqVjufZcdAZGneGv6Yz9ojOiOPZVt12VBse1ZE7jBRKh9KiqGnMvDRW0FTUX/fcAS9rPksqkxznb+KN2ODJ3hv9ZZ4n76rh8P2yYahWj4axw14gjmcGGUKfKGliOZttNCXHtly35xNhkvBOQA/GGXrMb7JhHesdR/Zq4Mix7jTUORxQBcZMhOcJixbdPoamJnW72uO1rU0SHIEeJbC0KLJIfDLIp9AsrLLa7imTWuUfhUZGqqVUNLxTjdzy6zasbqLRvbrjUIeRQu4Oi0LiI8vCLypoRtbeVwdslhQmZbYjYH4TasmE2+8Pww0SIu6HE8IbJVFaJOv5NTQ79XTX73GTQlj4AikVqjXlEPsT6DVKmEpiEfdjG5mxt8VNsuoW/KOp0YkOHPnPiWxUrdpBYztd0TA3hIPd7QoyZzVR9X1m0iKa/yFMsUEkeD29h+ZjOfula1m+r13GD39ZVE/wpEXWX5sU9r87921xGc3PUj27veESQqxfiNEjg+xDbdxqXBhHo0VtOvLg+MEU++vbxfoSiovmXjbxZaMa9A7Qh4klIyUGYoPKWHSgX20c4jc2Nxs+Dmm9yO+eb54bx8L5+3detKgKLT/4c8PCVD+tGNL9wEb/Q72HyAE9II1Wb33zbbpYaaLYWVuu793NvSqW84sR8nn+sFRazCUryVw+kynfS1ZWXpUymexKJXnvYiYj9yyKPclaVuxJJu+VM6VSvlzMtRcKheaD2qtsMV/KJMoPliZXSDufSJTyxWy29qBZWLvVzl0sL2YSafH8xUQika2x58+n06XcSnIll0mrPen0b3sS6cQwmcVyNlertJdnWeT8BLw4ykau6sPdAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeats);
export default __webpack_public_path__ + "static/media/seats.83373cd2d781cf0235d9080816abd298.svg";
export { ForwardRef as ReactComponent };